// extracted by mini-css-extract-plugin
export var actionButton = "_lv-0";
export var actionMenuContainer = "_lv-i";
export var bubble = "_lv-2";
export var bubbleActionMenu = "_lv-j";
export var bubbleContext = "_lv-6";
export var bubbleItems = "_lv-7";
export var customer = "_lv-3";
export var divider = "_lv-8";
export var fileList = "_lv-9";
export var hiddenComment = "_lv-o";
export var infoAbove = "_lv-a";
export var internal = "_lv-4";
export var lightActionButton = "_lv-1";
export var link = "_lv-b";
export var merchant = "_lv-5";
export var message = "_lv-c";
export var profilePicture = "_lv-e";
export var quillToolbarContainer = "_lv-f";
export var senderDate = "_lv-g";
export var senderDateCustomer = "_lv-h";
export var senderName = "_lv-d";
export var time = "_lv-k";
export var uploadedImage = "_lv-l";
export var username = "_lv-m";
export var xsmall = "_lv-n";